export enum GermanyIdType {
  Steueridentifikationsnummer = 'steuer_id',
  Sozialversicherungsnummer = 'social_security_number',
  Reisepass = 'de_passport',
  Personalausweis = 'de_id_card',
}
